import { apiPost } from '../../../utils/api';

export const bulkLockPlans = (site_ids, lock_plan, annotation) => {
  return apiPost('/sites', 'bulk_lock_site_plan', {
    site_ids,
    lock_plan,
    adm_action_annotation: annotation,
  });
};
